import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  Dimmer,
  Header,
  Loader,
  Segment,
  Table,
} from "semantic-ui-react";
import useApiPangeo from "../../hooks/useApiPangeo";
import Moment from "react-moment";
import { voltarOuDashboard } from "../../utils/navegacao";

function PedidosDesligamento() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { data, titulos, isLoading, getPedidosDesligamento } = useApiPangeo();

  useEffect(() => {
    getPedidosDesligamento();
  }, [getPedidosDesligamento, search]);

  return (
    <div>
      <div className="clearfix">
        <Header as="h3" style={{ float: "left" }}>
          Pedidos de desligamento no mês
        </Header>
        <div className="breadcrumb-com-voltar">
          <Button basic size="small" onClick={() => voltarOuDashboard(navigate)}>
            Voltar
          </Button>
          <Breadcrumb>
          <Breadcrumb.Section to="/" link as={Link}>
            Home
          </Breadcrumb.Section>
          <Breadcrumb.Divider />
          <Breadcrumb.Section active>Pedidos de desligamento no mês</Breadcrumb.Section>
          </Breadcrumb>
        </div>
      </div>

      <Segment>
        <Dimmer active={isLoading} inverted>
          <Loader>Aguarde ...</Loader>
        </Dimmer>
        <Table unstackable celled collapsing className="dnxTable">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Ex-filiado</Table.HeaderCell>
              <Table.HeaderCell>Empresa</Table.HeaderCell>
              <Table.HeaderCell>Regional</Table.HeaderCell>
              <Table.HeaderCell>Data do desligamento</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {! isLoading ? data?._embedded?.['socio']?.map((row) => {
              return <Table.Row key={row.id}>
              <Table.Cell>
                {row.nome} <small>Sindical: {row.sind}</small>
              </Table.Cell>
              <Table.Cell>({row._embedded.unidade.peju}-{row._embedded.unidade.seq}) {row._embedded.unidade.nome}</Table.Cell>
              <Table.Cell>{row._embedded.unidade.subregi.descricao}</Table.Cell>
              <Table.Cell>
                <Moment
                  format="DD/MM/YYYY"
                  date={row?.dtSitu?.date}
                />
              </Table.Cell>
            </Table.Row>
            }) : null}
          </Table.Body>
        </Table>
      </Segment>
    </div>
  );
}

export default PedidosDesligamento;
